import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { Stack, Typography } from "@mui/material";

const PageNotFound = () => {
  return (
    <StyledPageNotFound>
      <Stack direction={"row"} justifyContent={"center"} alignItems={"center"}>
        <div>
          <Image>
            <h1>404</h1>
          </Image>
          <ContentBox>
            <h3 className="h2">Look like you're lost</h3>
            <Typography>the page you are looking for not avaible!</Typography>
            <Link to="/" className="link_404">
              Go to Home
            </Link>
          </ContentBox>
        </div>
      </Stack>
    </StyledPageNotFound>
  );
};

const StyledPageNotFound = styled.section`
  padding: 40px 0;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 1px 2px 7px 0px rgba(0, 0, 0, 0.05);
  width: 100%;
  min-height: 100vh;

  > img {
    width: 100%;
  }
`;

const Image = styled.div`
  background-image: url("/404.gif");
  height: 400px;
  background-position: center;
  background-repeat: no-repeat;
  > h1 {
    font-size: 80px;
    text-align: center;
  }
`;

const ContentBox = styled.div`
  text-align: center;
  > h3 {
    font-size: 80px;
  }
`;

const Link = styled(NavLink)`
  color: #fff !important;
  padding: 10px 20px;
  background: #39ac31;
  margin: 20px 0;
  display: inline-block;
`;

export default PageNotFound;
